/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { theme } from "@nordcloud/gnui";

export function SuccessScreen() {
  return (
    <div
      css={{
        maxWidth: "925px",
        margin: "0 auto 3rem",
        paddingTop: theme.spacing.spacing06,
        textAlign: "center",
      }}
    >
      You have submitted the required information. <br />
      Your capacity data will be visible in IBM&nbsp;Multicloud&nbsp;Accelerator
      in the next 48 hours.
    </div>
  );
}
